import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { InputAppErrorDisplay } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';
import { PersistentStorageService } from '../../persistent-storage/persistent-storage.service';
import {
  ClearAllStorageAndReload,
  NoResetAppCacheAction,
  ResetAppCacheStoreActionTypes,
} from './reset-app-cache-db.actions';

@Injectable({
  providedIn: 'root',
})
export class ResetAppCacheStoreEffects {
  constructor(
    private action$: Actions,
    private persistentStorageService: PersistentStorageService,
    private inputAppErrorUtil: InputAppErrorDisplay,
    private translate: TranslateService,
  ) {}

  ClearAllStorageAndReload$ = createEffect(() => {
    return this.action$.pipe(
      ofType<ClearAllStorageAndReload>(ResetAppCacheStoreActionTypes.ClearAllStorageAndReload),
      switchMap(() => {
        return from(
          this.inputAppErrorUtil.presentLoadingWithId(
            'RESETTING_APP_CACHE',
            this.translate.instant('reset_app_cache.resetting_app_cache'),
          ),
        ).pipe(take(1));
      }),
      switchMap(() => {
        return from(this.persistentStorageService.clearExceptKeys([])).pipe(take(1));
      }),
      switchMap(() => {
        return from(this.inputAppErrorUtil.dismissLoadingWithId('RESETTING_APP_CACHE')).pipe(
          take(1),
          map(() => {
            window.location.reload();
            return new NoResetAppCacheAction();
          }),
        );
      }),
    );
  });
}
